import * as React from 'react';
import { Link } from 'react-router-dom';
import { AgGridReact } from 'ag-grid-react'; // React Data Grid Component
import actionTypes from '../../../../actions/ActionTypes';
import "ag-grid-community/styles/ag-grid.css"; // Mandatory CSS required by the Data Grid
import "ag-grid-community/styles/ag-theme-quartz.css"; // Optional Theme applied to the Data Grid
import DefaultsStore from '../../../../stores/DefaultsStore';

import DefaultSidebar from './DefaultsSidebar';

class DefaultHome extends React.Component {
  constructor(props) {
    super(props);
    // state
    this.state = {
      showGrid: false,
      rowData: [

      ],
      colDefs: [
        { field: "defaultName", headerName: "Default", filter: true, cellRenderer: this.EditButton },
        { field: "identifier", singleClickEdit: true, editable: true },
        { field: "businessProcessName", headerName: "Business Process", editable: true },
        { field: "readerName" },
        { field: "templateName" },
        { field: "defaultValue", headerName: "Default Assignment" }

      ],
      gotoDefaultId: 0,
      pagination: true,
      paginationPageSize: 20,
      paginationPageSizeSelector: [20,40,100]
    };

    this.onDefaultChange = this.onDefaultChange.bind(this);
    this.goToDefault = this.goToDefault.bind(this);
  }

  componentDidMount() {
    DefaultsStore.addChangeListener(this.onDefaultChange);
    let list = DefaultsStore.getDefaults();
    if(list !== undefined)
    {
      console.log(list);
      this.setState({rowData: list, showGrid: true});
    }

  }

  goToDefault(p) {
    console.log(p.data);
    this.setState({gotoDefaultId: p.data.defaultsDBId}, () => {
      let link = document.getElementById('gotoDefaultLink');
      link.click();
    });
  }

  EditButton = p => {

    return <><button onClick={() => this.goToDefault(p)} className="btn btn-primary btn-sm me-2" ><i className='fa-solid fa-pencil' /></button>{' '}{p.data.defaultName}</>;
  }

  componentWillUnmount() {
    DefaultsStore.removeChangeListener(this.onDefaultChange);
  }

  onDefaultChange() {
    let lastChange = DefaultsStore.getLastAction();
    if(lastChange === actionTypes.GetDefaults)
    {
      let list = DefaultsStore.getDefaults();
      console.log(list);
      this.setState({rowData: list, showGrid: true});
    }
  }

  render() {
    return (
      <div className='container-fluid' style={{ height: '100%' }}>
        <div className='row flex-nowrap' style={{ height: '100%' }}>
          <DefaultSidebar activePage='bp' />
          <div className='mt-2 me-2'>
            <div
              className="ag-theme-quartz" // applying the Data Grid theme
              style={{ height: 500, width: 1250 }} // the Data Grid will fill the size of the parent container
            >
              {this.state.showGrid &&
                <AgGridReact
                    rowData={this.state.rowData}
                    columnDefs={this.state.colDefs}
                    pagination={this.state.pagination}
                    paginationPageSize={this.state.paginationPageSize}
                    paginationPageSizeSelector={this.state.paginationPageSizeSelector}
                    enableCellTextSelection={true}
                    ensureDomOrder={true}
                />
              }
            </div>
          </div>
        </div>
        <Link
            id='gotoDefaultLink'
            className='nav-link'
            to={`/Admin/Defaults/${
              this.state.gotoDefaultId
            }`}
            style={{ display: 'none' }}
          ></Link>
      </div>
    );
  }
}

export default DefaultHome;
